import { LOCALSTORAGES } from "@/constants/constant";
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAccount, useAccountEffect } from "wagmi";

const AuthenticatedRoute: React.FC = () => {
  const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  const location = useLocation();
  const navigate = useNavigate();

  const { address, isConnected } = useAccount();

  // useEffect(() => {
  //   if (isConnected && address) {
  //     console.log("Connected address:", address);
  //   }

  //   if (!isConnected) {
  //     // remove token & redirect if wallet disconnected
  //     localStorage.removeItem(LOCALSTORAGES.TOKEN);
  //     navigate("/");
  //   }
  // }, []);

  // useAccountEffect({
  //   onConnect({ address }) {},
  //   onDisconnect() {
  //     console.log("aaya");
  //     localStorage.removeItem(LOCALSTORAGES.TOKEN);
  //     navigate("/");
  //   },
  // });
  // if (!isConnected) {
  //   localStorage.removeItem(LOCALSTORAGES.TOKEN);
  //   navigate("/");
  // }

  if (!token) {
    // Not authenticated → send to home
    return (
      <Navigate
        to="/"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }

  return <Outlet />; // Render child routes
};

export default AuthenticatedRoute;
